import { Stack } from "@mui/material";
import CustomPopover, { usePopover } from "src/components/custom-popover";

interface Props {
    rowId: string;
    popperRef: {current: {rowId: string | null}};
    children: React.ReactNode;
    popper: React.ReactNode;
    /** Horizontal alignment of the cell content (default: centered). */
    justifyContent?: 'center' | 'flex-start';
}

const PopperCell = ({ rowId, popperRef, children, popper, justifyContent = 'center' }: Props) => {
    const popover = usePopover();
    const onPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        popover.onOpen(event);
        popperRef.current.rowId = rowId;
    };
    const onPopoverClose = () => {
        popover.onClose();
        if (popperRef.current.rowId === rowId) {
            popperRef.current.rowId = null;
        }
    };

    return (
        <>
            <Stack
                onMouseEnter={onPopoverOpen}
                onMouseLeave={onPopoverClose}
                aria-owns={popover.open ? "clicks-split-popover" : undefined}
                aria-haspopup="true"
                direction="row"
                alignItems="center"
                justifyContent={justifyContent}
                spacing={1}
                sx={{ width: "100%", height: "50px", minHeight: "50px" }}
            >
                {children}
            </Stack>
            <CustomPopover
                open={popover.open}
                onClose={popover.onClose}
                anchorEl={popover.open}
                hiddenArrow={true}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                slotProps={{
                    paper: {
                        sx: {
                            p: 0,
                            m: 0,
                        },
                    },
                    root: {
                        sx: {
                            pointerEvents: "none",
                        },
                    },
                }}
                disableRestoreFocus
            >
                {popper}
            </CustomPopover>
        </>
    );
};

export default PopperCell;